import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ElementRenderer, generateElementKey } from '../ElementRenderer.js';
import { propToText, toText } from '../layout.js';
import { Tooltip as ShadcnTooltip, TooltipContent, TooltipProvider, TooltipTrigger, } from '../ui/tooltip.js';
export function Tooltip({ element }) {
    const { children, props, content } = element;
    const tooltipText = toText(content) || propToText(props.text) || propToText(props.content) || '';
    // Check for position flags (:top, :bottom, :left, :right) or position prop
    let side = 'top';
    if (props.bottom === true)
        side = 'bottom';
    else if (props.left === true)
        side = 'left';
    else if (props.right === true)
        side = 'right';
    else if (props.position)
        side = props.position;
    const hasChildren = children && children.length > 0;
    // If no children, render as a static tooltip bubble (for showcase/demo)
    if (!hasChildren) {
        return (_jsx("div", { className: "px-3 py-1.5 text-xs bg-primary text-primary-foreground rounded-md", children: tooltipText }));
    }
    // With children: wrap them and show tooltip on hover
    return (_jsx(TooltipProvider, { children: _jsxs(ShadcnTooltip, { children: [_jsx(TooltipTrigger, { asChild: true, children: _jsx("span", { className: "inline-block", children: children.map((child, i) => (_jsx(ElementRenderer, { node: child }, generateElementKey(child, i)))) }) }), tooltipText && _jsx(TooltipContent, { side: side, children: tooltipText })] }) }));
}
//# sourceMappingURL=Tooltip.js.map